import { Component } from '@angular/core';

import { Layout } from './components/layout/layout';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [Layout],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App {
  title = 'powerbi-reports-app';
}
